import React, { Fragment } from 'react'
import actions from 'redux/actions'
import { useEffect } from 'sb-hooks'
import { constants, mixpanel } from 'common/helpers'

import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import DialogModal from 'components/_new/modal/DialogModal/DialogModal'
import Overlay from 'components/_new/layout/Overlay/Overlay'
import Title from 'components/_new/typography/deprecated/Title/Title'
import Text from 'components/_new/typography/Text/Text'
import Icon from 'components/_new/ui/Icon/Icon'

import s from './OfferTest25offModal.scss'
import messages from './messages'

import bird25off from './images/bird25off.svg'


const couponCode = 'unsub25year'

const close = () => actions.models.modals.close(constants.modals.cancelSubscription.offerTest25off)

const createHandleAccept = (type) => () => {
  mixpanel.track(constants.analyticsEvents.cancelOffer25off.accept, {
    type: `25% off ${type}`,
  })

  actions.models.ui.showRequestLoader()
  actions.models.subscription.applyCoupon(couponCode)
    .then(() => {
      actions.models.modals.open(constants.modals.cancelSubscription.offerTest25offSuccess)
      // set closed prolongOfferModal to give discount offers only once
      actions.models.ui.setClosedPopup('prolongOfferModal')
      close()
    })
    .finally(() => actions.models.ui.hideRequestLoader())
}

const createHandleCancel = (reasonName) => () => {
  actions.models.subscription.unsubscribe({ reason: reasonName })
    .then(({ isRefundAvailable, refund }) => {
      if (isRefundAvailable || refund) {
        actions.models.modals.open(constants.modals.cancelSubscription.Refund, refund)
      }
      else {
        actions.models.modals.open(constants.modals.cancelSubscription.SubscriptionWasCancelled)
      }

      close()
    })
}

const OfferTest25offModal = ({ data: { reasonName, unsubscribeOfferTestAbValue } }) => {
  const type = unsubscribeOfferTestAbValue === 'b' ? 'relative' : 'absolute'

  useEffect(() => {
    mixpanel.track(constants.analyticsEvents.cancelOffer25off.popup, {
      type: `25% off ${type}`,
    })
  }, [ type ])

  const buttonAcceptProps = {
    title: messages.accept,
    onClick: createHandleAccept(type),
  }

  const buttonCancelProps = {
    title: messages.cancel,
    color: 'transparent',
    onClick: createHandleCancel(reasonName),
  }

  const titleProps = type === 'relative'
    ? { message: messages.relativeTitle, size: 'md' }
    : { message: messages.absoluteTitle, size: 'sm' }

  const textClassName = type === 'absolute' ? s.absoluteText : null

  return (
    <Fragment>
      <ModalContainer>
        <Overlay onClick={close} />
        <DialogModal
          leftButton={buttonAcceptProps}
          rightButton={buttonCancelProps}
          onClose={close}
        >
          <div className={s.container}>
            {
              type === 'relative' ? (
                <img className={s.bird} src={bird25off} alt="" />
              ) : (
                <div className={s.absoluteTop}>
                  $14.95&nbsp;
                  <Icon className={s.arrow} name="rightArrow" />
                  &nbsp;$11.25
                </div>
              )
            }
            <Title {...titleProps} html />
            <Text className={textClassName} message={messages.text} html />
          </div>
        </DialogModal>
      </ModalContainer>
    </Fragment>
  )
}


export default OfferTest25offModal
